module.exports = __webpack_public_path__ + "static/img/background.efb6b645.svg";